<section class="section-timeline">
	<div class="timeline" :class="{ 'is-visible': isVisible }"></div>
	<div ref="list" class="timeline-event-list">
		<template v-for="(show, index) in shows" :key="index">
			<div v-if="show.isClosestToToday && !isClosestShowBeforeToday" class="today timeline-event" :class="{ 'is-visible': isVisible }" :style="getDelay(index)">
				<h2>Zukünftige<br />Veranstaltungen</h2>
			</div>

			<div class="timeline-event flickity-cell" :class="{ 'is-visible': isVisible, 'has-link': show.url }" :style="getDelay(index)">
				<div class="centerHelperOuter">
					<div class="centerHelperInner">
						<a :href="show.url">
							<h3 class="title is-4 timeline-event__title">
								<span class="timeline-event__date">
									{{ show.dateTimeFormatted }}
									<template v-if="show.additionalShowsCount > 0">
										<br />
										<em>{{ show.additionalShowsCount }} weitere Vorstellung<template v-if="show.additionalShowsCount > 1">en</template></em>
									</template>
								</span>
								{{ show.name }}
							</h3>
							<div class="timeline-event__location">{{ show.location }}</div>
							<div v-if="show.shortDescription" class="timeline-event__description">
								{{ show.shortDescription }}
							</div>
						</a>
					</div>
				</div>
			</div>

			<div v-if="show.isClosestToToday && isClosestShowBeforeToday" class="today timeline-event" :class="{ 'is-visible': isVisible }" :style="getDelay(index)">
				<h2>ab Heute</h2>
			</div>
		</template>
	</div>
</section>
